import React from 'react';
import PropTypes from 'prop-types';

import { SelectStandalone } from '~components/forms/inputs/Select';
import Label from '../forms/Label';
import { stateEnums } from '../../utils/enums';

export default function StatePicker({ value, onSelect }) {
  const handleChange = (evt) => {
    onSelect(evt.target.value);
  };

  const options = [{ value: '', option: 'Select a state' }].concat(stateEnums);

  return (
    <div className='form-control w-full'>
      <Label htmlFor='leo-state-picker'>State</Label>
      <SelectStandalone
        name='leo-state'
        elementId='leo-state-picker'
        onChange={handleChange}
        value={value}
      >
        {/* eslint-disable-next-line no-shadow */}
        {options.map(({ option, value }) => (
          <option key={`${value}`} value={value}>
            {option}
          </option>
        ))}
      </SelectStandalone>
    </div>
  );
}

StatePicker.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};
